import { CreateTestErrorEventRequest } from '../../../services/api';

/** Eine Test-Vorlage — befüllt beim Auswählen alle Felder des Test-Event-Dialogs, bleibt danach frei editierbar. */
export interface ErrorEventTestTemplate {
  id: string;
  label: string;
  values: CreateTestErrorEventRequest;
}

/**
 * Hardcodierte Vorlagen für den Test-Event-Dialog.
 *
 * Bewusst im Frontend hinterlegt statt aus der DB geladen — es handelt sich
 * um feste Beispiel-Szenarien, keine verwaltbaren Stammdaten. Vorlage 4 ist
 * absichtlich schema-invalide (falscher `errorIdentifier`-Stil), um einen
 * Landung in der Dead Letter Queue zu provozieren.
 */
export const ERROR_EVENT_TEST_TEMPLATES: ErrorEventTestTemplate[] = [
  {
    id: 'sip-trunk-timeout',
    label: 'SIP-Trunk Timeout — livekit-bot',
    values: {
      service: 'livekit-bot',
      errorIdentifier: 'session_start_failed',
      customerId: '',
      agentId: '',
      sessionId: '',
      errorSource: 'sip-trunk',
      error: '(TEST) SIP-Trunk antwortete nicht innerhalb von 5000ms auf INVITE.',
      info: '(TEST) Der SIP-Trunk-Provider hat auf den ausgehenden Anrufversuch nicht reagiert — mögliche Ursachen: Provider-Ausfall, falsche Trunk-Konfiguration, Netzwerkproblem.',
      help: '(TEST) SIP-Trunk-Status beim Provider prüfen, Trunk-Konfiguration im Telephony-Setup des Agenten kontrollieren, bei wiederholtem Auftreten Provider-Support kontaktieren.',
    },
  },
  {
    id: 'llm-provider-call-failed',
    label: 'LLM-Provider-Fehler — llm-service',
    values: {
      service: 'llm-service',
      errorIdentifier: 'llm_provider_call_failed',
      customerId: '',
      agentId: '',
      sessionId: '',
      errorSource: 'openai',
      error: '(TEST) OpenAI API antwortete mit 503 Service Unavailable.',
      info: '(TEST) Der konfigurierte LLM-Provider war während der Chat-Completion-Anfrage nicht erreichbar — mögliche Ursachen: Provider-Ausfall, Rate-Limit, ungültiger API-Key.',
      help: '(TEST) Provider-Statusseite prüfen, API-Key und Kontingent im Provider-Dashboard kontrollieren, ggf. auf Fallback-Provider umstellen.',
    },
  },
  {
    id: 'hook-job-failed',
    label: 'Hook-Job fehlgeschlagen — chat-engine',
    values: {
      service: 'chat-engine',
      errorIdentifier: 'hook_job_failed',
      customerId: '',
      agentId: '',
      sessionId: '',
      errorSource: 'webhook',
      error: '(TEST) Webhook-Endpunkt antwortete mit 500 nach 3 Retries.',
      info: '(TEST) Der konfigurierte Hook-Endpunkt des Kunden hat die Zustellung dauerhaft abgelehnt — mögliche Ursachen: Endpunkt down, falsche URL, Server-Fehler beim Kunden.',
      help: '(TEST) Hook-Konfiguration des Kunden prüfen, Erreichbarkeit des Ziel-Endpunkts testen, Kunden über den Ausfall informieren.',
    },
  },
  {
    id: 'invalid-identifier-dlq-test',
    label: 'Invalider Identifier (DLQ-Test) — landet in der Dead Letter Queue',
    values: {
      service: 'livekit-bot',
      errorIdentifier: 'SessionStartFailed',
      customerId: '',
      agentId: '',
      sessionId: '',
      errorSource: '',
      error: '(TEST) Absichtlich schema-invalider errorIdentifier (PascalCase statt snake_case) zum Testen der Dead Letter Queue.',
      info: '(TEST) Diese Vorlage soll die Schema-Validierung im Error-Processor NICHT bestehen und dadurch in service-errors-dlq landen.',
      help: '(TEST) Kein echter Fehler — dient ausschließlich dem Test des DLQ-Pfads.',
    },
  },
];
